import React from 'react'; // eslint-disable-line
import { Button, Grid, Paper, Tooltip, Typography, withStyles } from '@material-ui/core';
import styles, { StyledComponent } from '../../../styles/styles';
import { AddCircle, Edit } from '@material-ui/icons';
import { LabeledValue } from '../../../controls/labeled-value';
import { FormModalView } from '../../../form-modal/views/form-modal';
import { OpenModal } from '../../../form-modal/actions';
import { connect, MapDispatchToProps } from 'react-redux';
import { State } from '../../../redux/root-reducer';
import { KeyTaxDirectiveDeclarationEditView } from './key-tax-directive-modal';
import { getLifeAssuredDetails } from '../../../life-assured-details/reducer';
import { AddFormModal } from '../../../form-modal';
import { BeneficiaryDetails, ClaimDecision, getDecisions, KeyTaxDirective } from '../../reducer';
import { OpenAddModal, openAddModalAction } from '../../../form-modal/actions';
import {
    FullWidthDatePicker,
    FullWidthSearchSelectField,
    FullWidthSelectField,
    FullWidthTextField,
    validations,
} from '../../../forms';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { requiredValidator } from '../../../forms/validations';
import { NumberMask } from '../../../forms/input-masks/number-mask';
import {
    AddAndSubmitKeyTaxDirective,
    addAndSubmitKeyTaxDirectiveThunk,
} from '../../actions/key-tax-deirective-record';
import { CurrencyMask } from '../../../forms/input-masks/currency-mask';
import { getKeyTaxDirective } from './reducer';
import { KeyTaxDirectiveDetailsView } from './key-tax-directive-details';
import { Field } from 'react-final-form';
import { getClaim } from '../../../claim';
import { convertToNumber } from '../../../shared-functions';

interface OwnProps {}
interface StateProps {
    keyTaxDirectiveDeclaration?: string;
    keyTaxDirectives: KeyTaxDirective[];
    beneficiaries: BeneficiaryDetails[];
    decisions: ClaimDecision[];
}
interface DispatchProps {
    addAndSubmitKeyTaxDirective: AddAndSubmitKeyTaxDirective;
    openAddModal: OpenAddModal;
}

type Props = DispatchProps &
    StateProps &
    StyledComponent & {
        openModal: OpenModal;
        openAddModal: OpenAddModal;
    };

const keyTaxDirectiveView: React.FunctionComponent<any> = ({
    keyTaxDirectiveDeclaration,
    openAddModal,
    classes,
    addAndSubmitKeyTaxDirective,
    keyTaxDirectives,
    decisions,
    beneficiaries,
}: any) => {
    const KeyTaxDirectiveAddFormModal = AddFormModal<KeyTaxDirective>();
    const requestTaxDirectiveDeclaration = () => {
        openAddModal({
            modalContent: <FormModalView formView={KeyTaxDirectiveDeclarationEditView} />,
        });
    };

    const color = false ? 'disabled' : 'secondary';
    const addDisabled =
        keyTaxDirectiveDeclaration === 'No' || keyTaxDirectiveDeclaration === null
            ? 'disabled'
            : 'secondary';

    const blankInformationRecord: KeyTaxDirective = {
        id: '',
        assessorName: '',
        amountApplied: '',
        status: '',
        keyTaxReferenceNumber: '',
    };

    const openAddView = () => {
        openAddModal({
            modalContent: (
                <KeyTaxDirectiveAddFormModal
                    blankRecord={blankInformationRecord}
                    recordDetailView={
                        <KeytaxDirectiveDetailView
                            addAndSubmitKeyTaxDirective={addAndSubmitKeyTaxDirective}
                            openAddModal={openAddModal}
                            keyTaxDirectives={keyTaxDirectives}
                            openModal={openAddModal}
                            heading={'Add Tax Directive feedback From KeyTax'}
                            decisions={decisions}
                            classes={classes}
                            beneficiaries={beneficiaries}
                        />
                    }
                    addRecord={keyTaxDirective => addAndSubmitKeyTaxDirective(keyTaxDirective)}
                />
            ),
            modalData: {},
        });
    };

    return (
        <React.Fragment>
            <Grid item xs={12} className={classes.marginTop} container justify="flex-end">
                <Tooltip title="Request Tax Directive">
                    <Button
                        id="RequestTaxDirective"
                        onClick={() => openKeyTaxPortal()}
                        style={{ textTransform: 'none' }}
                    >
                        <Grid container justify="flex-start">
                            <AddCircle color={color} />

                            <Typography
                                variant="subtitle2"
                                style={{ marginLeft: 4, textAlign: 'left' }}
                            >
                                Request Tax Directive
                            </Typography>
                        </Grid>
                    </Button>
                </Tooltip>
            </Grid>
            <Paper className={classes.paper}>
                <Grid item xs={12} spacing={2}>
                    <Grid item xs={6}>
                        <Typography style={{ fontWeight: 'bold' }}>
                            Tax Directive Feedback
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <LabeledValue
                            label="Have you applied for a Tax directive on KeyTax?"
                            value={keyTaxDirectiveDeclaration}
                        />
                    </Grid>
                    <Grid item xs={12} container justify="flex-end">
                        <Tooltip title="Request Tax Directive Declaration">
                            <Button
                                id="RequestTaxDirectiveDeclaration"
                                color="secondary"
                                onClick={requestTaxDirectiveDeclaration}
                            >
                                <Edit />
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid item xs={12}>
                    <Grid item xs={12} container justify="flex-end">
                        <Tooltip title="Add Tax Directive Decision">
                            <Button
                                id="addTaxDirectiveDecision"
                                onClick={openAddView}
                                style={{ textTransform: 'none' }}
                                disabled={isKeyTaxDirective()}
                            >
                                <Grid container justify="flex-start">
                                    <AddCircle color={addDisabled} />

                                    <Typography
                                        variant="subtitle2"
                                        style={{ marginLeft: 4, textAlign: 'left' }}
                                    >
                                        Add Tax Directive Decision
                                    </Typography>
                                </Grid>
                            </Button>
                        </Tooltip>
                    </Grid>
                    <Paper className={classes.paper}>
                        <Grid item xs={12} container justify="flex-end">
                            {keyTaxDirectives.map((record: KeyTaxDirective, index: number) => {
                                return (
                                    <KeyTaxDirectiveDetailsView
                                        classes={classes}
                                        index={index}
                                        key={`Summary-${index}`}
                                        keyTaxDirective={record}
                                    />
                                );
                            })}
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    );

    function isKeyTaxDirective() {
        if (keyTaxDirectiveDeclaration === 'Yes') {
            return false;
        }
        return true;
    }

    function openKeyTaxPortal() {
        const keyTaxUrl = `https://qkeytaxweb.liberty.fin-za.net/web/#/`;
        window.open(keyTaxUrl);
    }
};

type Prop = Props &
    StyledComponent & {
        heading: React.ReactNode;
    };
const KeytaxDirectiveDetailView = ({ decisions, beneficiaries, heading, classes }: Prop) => {
    return (
        <React.Fragment>
            <Typography variant="h5" className={classes.spacedTypography}>
                {heading}
            </Typography>

            <Grid container spacing={5}>
                <Paper className={classes.paper}>
                    <Grid
                        container
                        spacing={5}
                        justify="flex-start"
                        style={{ marginBottom: '40px' }}
                    >
                        <Grid item xs={6}>
                            <FullWidthSearchSelectField
                                name="decisionId"
                                label="Policy"
                                validate={requiredValidator}
                                options={filterDecisions(decisions)}
                                disabled={false}
                            />
                        </Grid>
                        <Field
                            name="."
                            subscription={{ value: true }}
                            component={({ input: { value: values } }) => {
                                setMaximumAmountPayable(values);
                                return null;
                            }}
                        />
                        <Grid item xs={6}>
                            <FullWidthDatePicker
                                name="dateRequested"
                                validate={requiredValidator}
                                disableFuture
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FullWidthTextField
                                name="amountApplied"
                                mask={CurrencyMask}
                                validate={validations.requiredValidator}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FullWidthTextField
                                name="keyTaxReferenceNumber"
                                label="Directive Number"
                                validate={validations.requiredValidator}
                                mask={NumberMask}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FullWidthDatePicker
                                name="dateReturned"
                                validate={requiredValidator}
                                disableFuture
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FullWidthTextField
                                name="amountReturned"
                                label="Sars Amount"
                                mask={CurrencyMask}
                                parse={convertToNumber}
                                validate={validations.requiredValidator}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FullWidthSelectField
                                name="status"
                                options={[
                                    {
                                        value: 'Successful',
                                        label: 'Successful',
                                    },
                                    {
                                        value: 'Unsuccessful',
                                        label: 'Unsuccessful',
                                    },
                                    {
                                        value: 'Pending',
                                        label: 'Pending',
                                    },
                                ]}
                                validate={requiredValidator}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} justify="flex-start">
                        <Grid item xs={12}>
                            <LabeledValue label="The tax directive is valid for this period:" />
                        </Grid>
                        <Grid style={{ marginTop: '50px', marginLeft: '10px' }}>
                            <Typography>From:</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FullWidthDatePicker label="Date" name="startDate" disableFuture />
                        </Grid>
                        <Grid style={{ marginTop: '50px' }}>
                            <Typography>To:</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FullWidthDatePicker label="Date" name="endDate" />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    );
};

function filterDecisions(decisions: ClaimDecision[]) {
    const filteredDecisions: any = [];
    decisions.forEach(d => {
        filteredDecisions.push({
            value: d.decisionId,
            label: d.decisionLabel,
        });
    });
    return filteredDecisions;
}

function setMaximumAmountPayable(values: any) {
    values.maxValue = values.maximumAmountPayable;
}

const mapStateToProps = (state: State) => {
    const lifeAssured = getLifeAssuredDetails(state);
    const claim = getClaim(state);
    return {
        keyTaxDirectiveDeclaration: lifeAssured.keyTaxDirectiveDeclaration,
        keyTaxDirectives: getKeyTaxDirective(state),
        decisions: getDecisions(claim),
    };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch: ThunkDispatch<State, any, AnyAction>
) => ({
    addAndSubmitKeyTaxDirective: (keyTaxDirective: KeyTaxDirective) =>
        dispatch(addAndSubmitKeyTaxDirectiveThunk(keyTaxDirective)),
    openAddModal: options => dispatch(openAddModalAction(options)),
});

export const KeyTaxDirectiveView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(keyTaxDirectiveView));
